import { Component } from '@angular/core';
import { Route } from '../../utils/route';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { UserAnalyticsComponent } from './user-analytics/user-analytics.component';
import { CatalogueAnalyticsComponent } from './catalogue-analytics/catalogue-analytics.component';
import { ProductAnalyticsComponent } from './product-analytics/product-analytics.component';

@Component({
  selector: 'app-promoters',
  imports: [
    TabsComponent,
    UserAnalyticsComponent,
    CatalogueAnalyticsComponent,
    ProductAnalyticsComponent,
  ],
  templateUrl: './promoters.component.html',
  styleUrl: './promoters.component.scss',
})
export class PromotersComponent extends Route {}
